import { ModelMixin } from '../mixins';

export default function buildDfSlottedField(name, slotFn) {
  return {
    name: `DfSlotted${name.replace(/[^a-zA-Z0-9]/, '')}`,
    mixins: [ModelMixin({ deep: true })],
    props: {
      schema: {
        type: Object,
      },
      value: {},
    },
    methods: {
      handleNativeInput(event) {
        this.$emit('input', event.target.value);
      },
      handleVueInput(value) {
        this.$emit('input', value);
      },
    },
    render(h) {
      return h(
        'div',
        {
          class: {
            'df-slotted-field': true,
          },
        },
        [
          slotFn({
            schema: this.schema,
            value: this.model,
            onInput: (event) => {
              if (event instanceof Event) {
                this.handleNativeInput(event);
              } else {
                this.handleVueInput(event);
              }
            },
            onBlur: () => {
              this.$emit('blur');
            },
          }),
        ]
      );
    },
  };
}
